/* 
 *  Created by SGiri 07/16/2018
 */

export class CognosConstants {

  public static SEARCH_URL = "/search/cognossearch";

}


// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/cognos/util/cognos.constant.ts